<template>
	<div class="mb-40">
			<Header
			title="Home"
			icon="Home"
			>
			</Header>
			<SubHeader v-if="currentInvoiceData != undefined"
				:title="publisher + ' - ' + niceDateTime(currentInvoiceData.startDate)"
				subText="View the estimated totals for the current month's activity"
			>
            <template v-slot:stats>
                <StatBox
					name="Estimated totals for:"
					:number="niceDateTime(currentInvoiceData.startDate)"
					currency=""
					icon="Calendar"
					/>
					<StatBox
					name="Accrued balance"
					:number="currentInvoiceData.amount.toFixed(2)"
					currency="£"
					icon="BadgePoundSterling"
					/>
					<StatBox
					name="User cashback"
					:number="currentInvoiceData.endUserAmount.toFixed(2)"
					currency="£"
					icon="BadgePoundSterling"
					/>
					<StatBox
					name="Your commission"
					:number="currentInvoiceData.commissionAmount.toFixed(2)"
					currency="£"
					icon="BadgePoundSterling"
					/>
            </template>
			</SubHeader>
			<div class="my-6 pb-2 w-full">
				<p class="px-2 sm:px-3 text-[#302E81] text-sm font-medium">Your cashback program:</p>
				<div class="mt-2 mb-4 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-3 px-2 xl:gap-6">
					<LaunchPadCard
						title="Program offers"
						subText="Manage which cashback offers are available to use by your customers."
						icon="BadgePercent"
						link="/program-offers"
					/>
					<LaunchPadCard
						title="Cashback Ledger"
						subText="Look up user cashback activity and view cashback receivable statuses."
						icon="BookOpenText"
						link="/cashback-ledger"
					/>
					<LaunchPadCard
						title="Payouts"
						subText="Preview estimated upcoming payouts and review your program's payout history."
						icon="BadgePoundSterling"
						link="/payouts"
					/>
				</div>
				<p class="px-2 sm:px-3 text-[#302E81] text-sm font-medium">Retailer catalogue:</p>
				<div class="mt-2 mb-4 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-3 px-2 xl:gap-6">
					<LaunchPadCard
						title="Retailer catalogue"
						subText="View and manage our integrated retailer offers which are available to use."
						icon="Store"
						link="/retailer-catalogue"
					/>
					<LaunchPadCard
						title="Retailer approvals"
						subText="Review the status of requests to access retailer cashback offers."
						icon="ListTodo"
						link="/retailer-approvals"
					/>
				</div>
				<p class="px-2 sm:px-3 text-[#302E81] text-sm font-medium">System usage and billing:</p>
				<div class="mt-2 mb-4 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-3 px-2 xl:gap-6">
					<LaunchPadCard
						title="Transaction enrichment"
						subText="Monitor transaction enrichment activity and look up transactions processed for a given user."
						icon="Sparkles"
						link="/transaction-enrichment"
					/>
					<LaunchPadCard
						title="Bank connections"
						subText="Monitor bank connections and look up live and expired connections for a given user."
						icon="Landmark"
						link="/bank-connections"
					/>
					<LaunchPadCard
						title="Billing"
						subText="View estimated upcoming invoices & platform usage and review past month's invoices."
						icon="ReceiptText"
						link="/billing"
					/>
				</div>
				<p class="px-2 sm:px-3 text-[#302E81] text-sm font-medium">Manage your integration:</p>
				<div class="mt-2 mb-4 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-3 px-2 xl:gap-6">
					<LaunchPadCard
						title="Playground"
						subText="Test transactions and cashback offers based on your program offers"
						icon="Play"
						link="/playground"
					/>
					<LaunchPadCard
						title="API Keys"
						subText="Create, copy, deactivate and delete API Keys used to access Boogi APIs."
						icon="KeySquare"
						link="/api-keys"
					/>
					<LaunchPadCard
						title="Webhooks"
						subText="Create and monitor cashback webhook activity and real-time cashback events."
						icon="Webhook"
						link="/webhooks"
					/>

				</div>
			</div>
	</div>
	</template>
	
<script>
	import Header from '@/components/Header.vue';
	import SubHeader from '@/components/SubHeader.vue';
	import LaunchPadCard from '@/components/LaunchPadCard.vue';
	import StatBox from "@/components/StatBox.vue";
	import { DateTime } from 'luxon';


	
	export default {
		name:'LaunchPad',
		components:{
			Header,
			SubHeader,
			LaunchPadCard,
			StatBox
		},
		data(){
			return {
				publisher: localStorage.getItem('publisher'),
				currentInvoiceData:undefined

		}},
		mounted() {
        document.title = "Dashboard | Home";
    },
		computed:{
		},
		created(){
			this.getCurrentPayout()
		},
	
	
		methods:{

			niceDateTime(dateObject) {
			return DateTime.fromMillis(dateObject).toFormat('MMMM yyyy')
		},

			async getCurrentPayout(){
			try {
				const token = localStorage.getItem('token')
				const api  = localStorage.getItem('apiType')

                this.loading = true

				const response = await fetch(`https://${api}.boogi.io/private/api/client/payout/current`, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						"Authorization": `${token}`,
					},
				});

				if (response.ok) {
					var object = await response.json()

                    this.currentInvoiceData = object
				}
				
			} catch (error) {
				return;
			}

		},

		}
	
	}
	</script>
	
	<style>
	
	</style>